import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Home from "./pages/Homepage";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(


      <App></App>


);
